export const mapConfigModelFieldNames = (displayColumnName: string) => {
  switch (displayColumnName.toLowerCase()) {
    case 'created by':
      return 'createdBy.name';
    case 'created':
      return 'createdBy.date';
    case 'modified by':
      return 'updatedBy.name';
    case 'modified':
      return 'updatedBy.date';
    default:
      return displayColumnName;
  }
};
